import { render } from "./WCBasicAddToCartButton.vue?vue&type=template&id=be7ec670&scoped=true&ts=true"
import script from "./WCBasicAddToCartButton.vue?vue&type=script&lang=ts"
export * from "./WCBasicAddToCartButton.vue?vue&type=script&lang=ts"

import "./WCBasicAddToCartButton.vue?vue&type=style&index=0&id=be7ec670&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7ec670"]])

export default __exports__